import React from "react";
import { Spinner } from "reactstrap";
type Props = {
  setLoading?: any;
};
const Spinners = (props: Props) => {
  return (
    <React.Fragment>
      <Spinner color="primary" className="position-absolute top-50 start-50" />
    </React.Fragment>
  );
};

export default Spinners;
